'use client';

import * as React from 'react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { Pagination, type PaginationProps } from 'ui';
import type { NormalizedSortBy } from '../_components/types';
import { pathPrefixAtom } from '../../_components/blog-state';

export interface BlogPaginationProps extends Omit<PaginationProps, 'calcUrl'> {
  tag: string;
  sortBy: NormalizedSortBy;
}

export function BlogPagination({
  tag,
  sortBy,
  ...props
}: BlogPaginationProps): JSX.Element {
  const urlPrefix = useAtomValue(pathPrefixAtom);
  const t = useTranslations('Blog.Pagination');
  return (
    <section className="border-t pt-5">
      <Pagination
        {...props}
        calcUrl={(index: number) => {
          return `${urlPrefix}/category/${tag}/${index}/${sortBy}#tag-tabs`;
        }}
        prevLabel={t('Previous')}
        nextLabel={t('Next')}
      />
    </section>
  );
}
